import { call, put, takeLatest } from 'redux-saga/effects'
import {
    dProductsAddItemSagaAC,
    dProductsBulkDeleteFromStoresSagaAC,
    dProductsBulkDeleteSagaAC,
    dProductsBulkOffSaleSagaAC,
    dProductsBulkPatchSagaAC,
    dProductsBulkRecoverySagaAC,
    dProductsChangeVATSagaAC,
    dProductsDeleteAllFromStoreSagaAC,
    dProductsDeleteAllSagaAC,
    dProductsDeleteItemSagaAC,
    dProductsEditItemSagaAC,
    dProductsExportDataSagaAC,
    dProductsImportDataSagaAC,
    dProductsRecoverItemSagaAC,
    dProductsRestoreDeletedItemWithNewDataSagaAC,
    dProductsSaveTemplateSagaAC,
    dProductsSetDataAC,
    dProductsSetDataSagaAC,
    dProductsSetPaginationAC
} from './dProductsActionCreators'
import { dashboardLoaderAC } from '../system/systemActionCreators'
import { IdProductsStateDataItem, typeProductsFilters } from './dProductsReducer'
import {
    addProductItem,
    bulkChangeItems, bulkDeleteFromStoreProducts, bulkDeleteProducts, bulkOffSaleProducts, bulkRecoverProducts,
    changeProductItem, deleteAllProducts, changeVatForAllProducts,
    deleteProductItem, deleteProductsFromStore, exportDataProducts,
    getProductList, importDataProducts, restoreWithNewDataProductItem, saveTemplateProductsFile
} from './dProductsAPI'
import { typeEditProductsItemObject } from 'components/containers/dashboard/dataProducts/popupContents/popupEdit'
import { typeAddProductsItemObject } from 'components/containers/dashboard/dataProducts/popupContents/popupAdd'
import {
    typeBulkChangeCategoryObject
} from 'components/containers/dashboard/dataProducts/popupContents/popupBulkChangeCategory'
import {
    typePagination,
    typeRequestPagination,
    paginationMapper,

} from '../system/constants'
import FileDownload from 'js-file-download'
import { errorGenerator, notificationCreator } from 'model/system/utils';
import { getLanguage } from 'model/axiosConfig';
import { languageForUrl } from 'locales/languages';

// Temp data list mapper
const tempDataMapper = (tempResponseData: any): IdProductsStateDataItem[] => {
    return tempResponseData.map((item: IdProductsStateDataItem) => {
        return (
            {
                checked: false,
                id: item.id,
                name: item.name,
                barcodes: item.barcodes,
                psid: item.psid!,
                units: item.units,
                integerUnit: item.integerUnit,
                marked: item.marked!,
                active: item.active!,
                deleted: item.deleted,
                category: item.category,
                stores: item.stores,
                vat: ( item.vat !== undefined && item.vat !== null ) ? item.vat * 100 : null,
                commissionTIN: item.commissionTIN,
                commissionPINFL: item.commissionPINFL,
                unitCode: item.unitCode,
                packageCode: item.packageCode,
                productOwnerType: item.productOwnerType
            }
        )
    })
}

// Get data function-generator
function* getData(payload: { filters: typeProductsFilters, paginationRequest: typeRequestPagination }) {

    let response = yield call(getProductList, payload)

    if (response.status === 200) {

        const tempData: IdProductsStateDataItem[] = tempDataMapper(response.data.content)
        const pagination: typePagination = paginationMapper(response.data)

        yield put(dProductsSetPaginationAC(pagination))

        yield put(dProductsSetDataAC(tempData))

    } else {
        yield errorGenerator(response)
    }
}

// ---------------------------------------------------------------------------------------------------------------------
// Set product list saga
export function* dProductsSetDataWorker(actionObject: {
    type: string,
    payload: { filters: typeProductsFilters, paginationRequest: typeRequestPagination }
}) {

    yield put(dashboardLoaderAC(true))

    yield getData(actionObject.payload)

    yield put(dashboardLoaderAC(false))

}

export function* dProductsSetDataWatcher() {
    yield takeLatest(dProductsSetDataSagaAC.type, dProductsSetDataWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Change product item saga
export function* dProductsEditItemWorker(actionObject: {
    type: string,
    payload: {
        itemObject: typeEditProductsItemObject,
        filters: typeProductsFilters,
        paginationRequest: typeRequestPagination
    }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(changeProductItem, actionObject.payload)


    if (response.status === 200) {

        yield notificationCreator('SUCCESS_CHANGE_ITEM')

        yield getData({
            filters: actionObject.payload.filters,
            paginationRequest: actionObject.payload.paginationRequest
        })

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}


export function* dProductsEditItemWatcher() {
    yield takeLatest(dProductsEditItemSagaAC.type, dProductsEditItemWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Add product item saga
export function* dProductsAddItemWorker(actionObject: {
    type: string,
    payload: {
        itemObject: typeAddProductsItemObject,
        filters: typeProductsFilters,
        paginationRequest: typeRequestPagination
    }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(addProductItem, actionObject.payload)

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_ADD_ITEM')

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsAddItemWatcher() {
    yield takeLatest(dProductsAddItemSagaAC.type, dProductsAddItemWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Delete product item saga
export function* dProductsDeleteItemWorker(actionObject: {
    type: string,
    payload: { itemId: string, filters: typeProductsFilters, paginationRequest: typeRequestPagination }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(deleteProductItem, { itemId: actionObject.payload.itemId })

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_DELETE_ITEM')

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsDeleteItemWatcher() {
    yield takeLatest(dProductsDeleteItemSagaAC.type, dProductsDeleteItemWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Recover product item saga
export function* dProductsRecoverItemWorker(actionObject: {
    type: string,
    payload: { itemId: string, filters: typeProductsFilters, paginationRequest: typeRequestPagination }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(bulkRecoverProducts, { bulkIdList: [ actionObject.payload.itemId ] })

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_RECOVER_ITEM')

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsRecoverItemWatcher() {
    yield takeLatest(dProductsRecoverItemSagaAC.type, dProductsRecoverItemWorker)
}

// ---------------------------------------------------------------------------------------------------------------------
//Bulk Recover product item saga
export function* dProductsBulkRecoverItemWorker(actionObject: {
    type: string,
    payload: { bulkIdList: string[], filters: typeProductsFilters, paginationRequest: typeRequestPagination }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(bulkRecoverProducts, { bulkIdList: actionObject.payload.bulkIdList })

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_RECOVER_ITEM')

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsBulkRecoverItemWatcher() {
    yield takeLatest(dProductsBulkRecoverySagaAC.type, dProductsBulkRecoverItemWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Bulk change items saga
export function* dProductsBulkChangeCategoryWorker(actionObject: {
    type: string,
    payload: {
        bulkObjectList: typeBulkChangeCategoryObject[],
        filters: typeProductsFilters,
        paginationRequest: typeRequestPagination
    }
}) {

    yield put(dashboardLoaderAC(true))

    // @ts-ignore
    let response = yield call(bulkChangeItems, actionObject.payload.bulkObjectList)

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_BULK_EDIT')

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsBulkChangeCategoryWatcher() {
    yield takeLatest(dProductsBulkPatchSagaAC.type, dProductsBulkChangeCategoryWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Bulk delete items saga
export function* dProductsBulkDeleteWorker(actionObject: {
    type: string,
    payload: { bulkIdList: string[], filters: typeProductsFilters, paginationRequest: typeRequestPagination }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(bulkDeleteProducts, { bulkIdList: actionObject.payload.bulkIdList })

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_BULK_DELETE')

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsBulkDeleteWatcher() {
    yield takeLatest(dProductsBulkDeleteSagaAC.type, dProductsBulkDeleteWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Bulk off-sale items saga
export function* dProductsBulkOffSaleWorker(actionObject: {
    type: string,
    payload: {
        productIds: string[],
        storeIds: string[],
        filters: typeProductsFilters,
        paginationRequest: typeRequestPagination
    }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(bulkOffSaleProducts, {
        productIds: actionObject.payload.productIds,
        storeIds: actionObject.payload.storeIds
    })

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_BULK_EDIT')

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsBulkOffSaleWatcher() {
    yield takeLatest(dProductsBulkOffSaleSagaAC.type, dProductsBulkOffSaleWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Bulk delete items from stores saga
export function* dProductsBulkDeleteFromStoresWorker(actionObject: {
    type: string,
    payload: {
        productIds: string[],
        storeIds: string[],
        filters: typeProductsFilters,
        paginationRequest: typeRequestPagination
    }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(bulkDeleteFromStoreProducts, {
        productIds: actionObject.payload.productIds,
        storeIds: actionObject.payload.storeIds
    })

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_BULK_EDIT')

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsBulkDeleteFromStoresWatcher() {
    yield takeLatest(dProductsBulkDeleteFromStoresSagaAC.type, dProductsBulkDeleteFromStoresWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Export data saga
export function* dProductsExportDataWorker(actionObject: {
    type: string,
    payload: { productIds: string[], storeIds: string[], lang: string }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(exportDataProducts, actionObject.payload)

    if (response.status === 200) {

        const blob = new Blob([ response.data ], {
            type:
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        FileDownload(blob, 'product-list-export.xlsx')

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsExportDataWatcher() {
    yield takeLatest(dProductsExportDataSagaAC.type, dProductsExportDataWorker)
}

// ---------------------------------------------------------------------------------------------------------------------
// Export data saga
export function* dProductsImportDataWorker(actionObject: {
    type: string,
    payload: { formData: FormData, filters: typeProductsFilters, paginationRequest: typeRequestPagination }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(importDataProducts, { formData: actionObject.payload.formData })

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_IMPORT')

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })

    } else if (response.status === 400) {
      const description = response.data?.description;

      if (description === 'The number of fields in the file must be equal to 15') {
        yield notificationCreator('ERROR_SERVER_BAD_IMPORT_FILE_FIELDS');
      } else if (description) {
        yield notificationCreator(description);
      } else {
        yield notificationCreator('ERROR_SERVER_BAD_IMPORT_FILE');
      }
    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsImportDataWatcher() {
    yield takeLatest(dProductsImportDataSagaAC.type, dProductsImportDataWorker)
}

// ---------------------------------------------------------------------------------------------------------------------
// Export data saga
export function* dProductsSaveTemplateWorker(actionObject: { type: string, payload: {} }) {

    yield put(dashboardLoaderAC(true))

    const lang = getLanguage()

    let response = yield call(saveTemplateProductsFile, languageForUrl[lang])

    if (response.status === 200) {

        const blob = new Blob([ response.data ], {
            type:
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        FileDownload(blob, 'template-file.xlsx')

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsSaveTemplateWatcher() {
    yield takeLatest(dProductsSaveTemplateSagaAC.type, dProductsSaveTemplateWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Delete items saga
export function* dProductsDeleteAllWorker(actionObject: {
    type: string,
    payload: { filters: typeProductsFilters, paginationRequest: typeRequestPagination }
}) {

    yield put(dashboardLoaderAC(true))


        let response = yield call(deleteAllProducts)

        if (response.status === 200) {

            yield notificationCreator('SUCCESS_BULK_DELETE')

            yield getData({
                              filters: actionObject.payload.filters,
                              paginationRequest: actionObject.payload.paginationRequest
                          })
        } else {
            yield errorGenerator(response)
        }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsDeleteAllWatcher() {
    yield takeLatest(dProductsDeleteAllSagaAC.type, dProductsDeleteAllWorker)
}

// Delete items saga
export function* dProductsDeleteAllFromStoreWorker(actionObject: {
    type: string,
    payload: { storeId: string | number, filters: typeProductsFilters, paginationRequest: typeRequestPagination }
}) {

    yield put(dashboardLoaderAC(true))

    let deletResponse = yield call(deleteProductsFromStore, { storeId: actionObject.payload.storeId })

    if (deletResponse.status === 200) {

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })

        yield notificationCreator('SUCCESS_DELETE_ITEMS')

    } else {
        yield errorGenerator(deletResponse)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsDeleteAllFromStoreWatcher() {
    yield takeLatest(dProductsDeleteAllFromStoreSagaAC.type, dProductsDeleteAllFromStoreWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Bulk change vatAllowedValue saga
export function* dProductsChangeVATWorker(actionObject: {
    type: string,
    payload: { filters: typeProductsFilters, paginationRequest: typeRequestPagination, vat: number }
}) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(changeVatForAllProducts, { vat: actionObject.payload.vat })

    if (response.status === 200) {

        yield notificationCreator('SUCCESS_CHANGE_ITEM')

        yield getData({
                          filters: actionObject.payload.filters,
                          paginationRequest: actionObject.payload.paginationRequest
                      })
    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dProductsChangeVATWatcher() {
    yield takeLatest(dProductsChangeVATSagaAC.type, dProductsChangeVATWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Change product item saga
export function* dProductsRestoreDeletedItemWithNewDataWorker(actionObject: {
    type: string,
    payload: {
        itemObject: typeEditProductsItemObject,
        filters: typeProductsFilters,
        paginationRequest: typeRequestPagination
    }
}) {

    yield put(dashboardLoaderAC(true))

    // 1 - do restore
    let responseRestore = yield call(bulkRecoverProducts, { bulkIdList: [ actionObject.payload.itemObject.id ] })
    let response: any
    // 2 - change fo new data
    if (responseRestore.status === 200) {
        let response = yield call(restoreWithNewDataProductItem, actionObject.payload)
        if (response.status === 200) {
            yield notificationCreator('SUCCESS_RECOVER_ITEM')
            yield getData({
                              filters: actionObject.payload.filters,
                              paginationRequest: actionObject.payload.paginationRequest
                          })
        } else {
            yield errorGenerator(response)
        }
    } else {
        yield errorGenerator(responseRestore)
    }
    yield put(dashboardLoaderAC(false))

    return ( response && response.status === 200 )
}

export function* dProductsRestoreDeletedItemWithNewDataWatcher() {
    yield takeLatest(dProductsRestoreDeletedItemWithNewDataSagaAC.type, dProductsRestoreDeletedItemWithNewDataWorker)
}
